// Generated by Claude Code
import { PartQuantityStepper } from '#components/domain/operations/parts/shared/part-quantity-stepper.tsx'
import { CurrencySelect } from '#components/domain/operations/parts/shared/currency-select.tsx'

export interface CostRateFieldsProps {
  /** The hourly amount as typed; blank when none. */
  amount: string
  onAmountChange: (amount: string) => void
  /** Fires with the settled amount on blur, Enter and each −/+ click. */
  onAmountCommit?: (amount: string) => void
  /** Shown in the blank amount field, e.g. the rate it falls back to. */
  amountPlaceholder?: string
  /** Accessible name of the amount field. */
  ariaLabel: string
  /** The selected currency code; blank when none. */
  currency: string
  onCurrencyChange: (currency: string) => void
  disabled?: boolean
}

/** An hourly cost rate's amount stepper and currency picker, side by side. */
export function CostRateFields({ amount, onAmountChange, onAmountCommit, amountPlaceholder, ariaLabel, currency, onCurrencyChange, disabled }: CostRateFieldsProps) {
  return (
    <div className="row g-2">
      <div className="col-7">
        <PartQuantityStepper
          value={amount}
          ariaLabel={ariaLabel}
          placeholder={amountPlaceholder}
          disabled={disabled}
          onChange={onAmountChange}
          onCommit={onAmountCommit}
        />
      </div>
      <div className="col-5">
        <CurrencySelect value={currency} disabled={disabled} onChange={onCurrencyChange} />
      </div>
    </div>
  )
}
